import React from 'react';
import { Board } from '../components/Board';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { Issues } from '../components/Issues';
import { Mission } from '../components/Mission';
import { Navbar } from '../components/Navbar';
import { News } from '../components/News';
import { Seo } from '../components/Seo';
import { Stats } from '../components/Stats';
export function Home() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-226" data-mp="24gsa5yc4ndsg">
      <Seo title="Arizona Local Control & Municipal Leadership" description="AZ City PAC unites Arizona municipal leaders, business leaders, and community advocates to protect local control, strengthen cities and towns, and advance responsible growth." schema={{
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'AZ City PAC',
      url: 'https://azcitypac.com',
      description: 'A statewide coalition protecting local control and advancing policies that strengthen Arizona cities and towns.',
      about: ['Arizona local control', 'municipal leadership', 'zoning and land use', 'infrastructure', 'public safety', 'economic development']
    }} data-id="element-227" data-mp="24hagxowf1aem" />
      <Navbar data-id="element-228" data-mp="2hxnjzirt4nt5" />

      <main className="flex-grow" data-id="element-229" data-mp="2hy72b0ldde7p">
        <Hero data-id="element-230" data-mp="2hzi8f72aey1z" />
        <Stats data-id="element-231" data-mp="2i00bonndacje" />
        <Mission data-id="element-232" data-mp="2d775dvc92w57" />
        <Issues data-id="element-233" data-mp="2d6p1qdn9dfn9" />
        <Board data-id="element-234" data-mp="2d65t5nji03lw" />
        <News data-id="element-235" data-mp="2d5mau5pxrd7c" />
        <FinalCTA data-id="element-236" data-mp="2d5w2ryujjufo" />
      </main>

      <Footer data-id="element-237" data-mp="287ukhg4xvz59" />
    </div>;
}